module.exports = __webpack_public_path__ + "img/surat_th.cc2e2af6.png";